<template>
  <mdb-card>
    <mdb-card-header class="pt-4 indigo">
      <mdb-card-title class="text-white"
        ><strong>{{ $t("import_access_codes_header") }}</strong></mdb-card-title
      >
    </mdb-card-header>
    <mdb-card-body>
      <FindPhoneUserDataFromImport />
      <mdb-row>
        <mdb-col md="12">
          <mdb-file-input
            sm
            @getValue="getFileInputValue"
            floating
            icon="paperclip"
            gradient="blue"
          />
        </mdb-col>
        <mdb-col md="6">
          <mdb-input
            v-model="name"
            type="text"
            :label="$t('import_access_codes_patch_name')"
            icon="pen"
            :rows="2"
          />
        </mdb-col>
        <mdb-col md="6">
          <mdb-input
            v-model="date"
            :is-valid="dateValid"
            :invalidFeedback="$t('import_access_codes_date_not_valid')"
            customValidation
            @change="handleOnChange"
            v-mdb-input-mask="'♠♠-♠♠-♠♠♠♠'"
            icon="calendar"
            :label="$t('import_access_codes_patch_valid_until')"
          />
        </mdb-col>
        <mdb-col md="6">
          <mdb-btn
            v-on:click="importAccessCodes"
            color="indigo"
            class="white-text"
            icon="paper-plane"
            >{{ $t("load") }}</mdb-btn
          >
        </mdb-col>
      </mdb-row>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbFileInput,
  mdbInputMask
} from "mdbvue";
import FindPhoneUserDataFromImport from '../components/FindPhoneUserDataFromImport.vue';

export default {
  name: "ImportAccessCodes",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbFileInput,
    FindPhoneUserDataFromImport
  },
  directives: {
    mdbInputMask
  },
  data() {
    return {
      name: "",
      date: "",
      processedDate: "",
      dateValid: true,
      postData: {},
      dataProductCodesData: {},
      importedProductCodes: [],
      importaccesscodespath: "/1.0/newbe/importnewproductcodepatch"
    };
  },
  methods: {
    handleOnChange(val) {
      if (val.length == 10) {
        try {
          this.processedDate = this.$luxon(val, {
            input: { format: "dd-MM-yyyy" },
            output: { format: "yyyy-MM-dd" }
          });
        } catch (error) {
          this.dateValid = false;
          this.processedDate = "";
          console.log(error);
        }
      } else {
        this.dateValid = true;
      }
    },
    getFileInputValue(val) {
      this.importedProductCodes = [];
      this.importedTelephoneNumbers = [];
      var _vue = this;
      this.$papa.parse(val[1], {
        complete: function(results) {
          console.log(results);
        },
        step: function(result) {
          _vue.importedProductCodes.push(result.data[1]);
        }
      });
      this.$papa.parse(val[2], {
        complete: function(results) {
          console.log(results);
        },
        step: function(result) {
          _vue.importedTelephoneNumbers.push(result.data[2]);
        }
      });
      console.log(val);
    },
    checkInputs() {
      if (this.processedDate === "" || this.importedProductCodes.length === 0)
        return false;
      else return true;
    },
    importAccessCodes() {
      if (!this.checkInputs()) {
        this.$notify.error({
          message: this.$t("import_access_codes_check_input"),
          position: "top right",
          timeOut: this.$store.state.notifytimeoutshort
        });
        return;
      }
      this.postData = {
        importproductcodesname: this.name,
        importproductcodesdate: this.processedDate,
        sessionid: this.$store.getters.getToken,
        importproductcodes: this.importedProductCodes
      };

      this.dataProductCodesData = JSON.stringify(this.postData);

      this.$http
        .post(this.importaccesscodespath, this.dataProductCodesData)
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("import_access_codes_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("import_access_codes_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
